import { useLanguageContext } from "../../../context/LanguageContext";
import useAxisConfigCreateRouteConfig from "../../../routes/configs/integrations/axis/AxisConfigCreateRouteConfig";
import useAxisConfigEditRouteConfig from "../../../routes/configs/integrations/axis/AxisConfigEditRouteConfig";
import useBasicColumnConfig from "../main/config/column/default/BasicColumnConfig";
import useBooleanColumnConfig from "../main/config/column/default/BooleanColumnConfig";
import DataTableConfig from "../main/config/dataTable/DataTableConfig";
import useCreateHeaderActionConfig from "../main/config/headerAction/default/CreateHeaderActionConfig";
import useDeleteRowActionConfig from "../main/config/rowAction/default/DeleteRowActionConfig";
import useEditRowActionConfig from "../main/config/rowAction/default/EditRowActionConfig";
import DataTable, { useDataTable } from "../main/DataTable";

function AxisConfigsDataTable() {
  const { translate } = useLanguageContext();

  //Create the datatable config
  const config = new DataTableConfig("axis/units");

  // //Set the datatable fetch info
  config.setFetchRequest("integrations/axis/units");

  //Set the datatable columns
  config.setColumns([
    useBasicColumnConfig("name"),
    useBasicColumnConfig("url"),
    useBasicColumnConfig("username"),
    useBasicColumnConfig("password"),
    useBasicColumnConfig("auth_method").setData(
      (row) =>
        row.auth_method.charAt(0).toUpperCase() + row.auth_method.slice(1),
    ),
    useBooleanColumnConfig("allow_visitor_plates").setActive(false),
    useBooleanColumnConfig("allow_employee_plates").setActive(false),
  ]);

  //Set the datatable row actions
  config.setRowActions([
    useEditRowActionConfig(
      "integrations/axis/config",
      useAxisConfigEditRouteConfig(),
    ).setTitle(
      translate("eva.main.entities.states.edit", [
        {
          key: "entities",
          value: translate("eva.main.entities.axis_config"),
        },
      ]),
    ),
    useDeleteRowActionConfig("integrations/axis/unit").setTitle(
      translate("eva.main.entities.states.delete", [
        {
          key: "entities",
          value: translate("eva.main.entities.axis_config"),
        },
      ]),
    ),
  ]);

  //Set the datatable header actions
  config.setHeaderActions([
    useCreateHeaderActionConfig(
      "integrations/axis/config",
      useAxisConfigCreateRouteConfig(),
    ).setTitle(
      translate("eva.main.entities.states.create", [
        {
          key: "entities",
          value: translate("eva.main.entities.axis_config"),
        },
      ]),
    ),
  ]);

  //Set the overall loading groups for the datatable row actions
  config.setRowActionsLoadingGroups(
    (row) => `${config.getDataTableKey()}_update_${row.id}`,
  );

  //Create the datatable object
  const dataTable = useDataTable(config);

  return <DataTable controller={dataTable} />;
}

export default AxisConfigsDataTable;
